export enum OrganizationRelationshipError {
  PERMISSION_IS_NOT_VALID = 'Permission is not valid',
  ORGANIZATION_RELATIONSHIP_ALREADY_EXISTS = 'A similar relationship already exists',
  EMAIL_ALREADY_STAFF = 'this email is already a staff member; remove them as staff first before adding as a promoter or partner',
}

export { OrganizationRelationshipKind } from './organizationRelationshipKind'
export {
  ExternalAccountKind,
  ExternalAccountType,
} from './organizationRelationshipKind'
